import { combineReducers } from 'redux';
import modal from './modal_reducer';

export default combineReducers({
  modal
});